// mensBraidOptions.js
export const mensBraidCountOptions = [
  { value: "2-6", label: "2–6 braids", price: 0 },
  { value: "8-10", label: "8–10 braids", price: 10 },
  { value: "12-14", label: "12–14 braids", price: 30 },
  { value: "16-18", label: "16–18 braids", price: 50 },
];

export const mensHairWashPrice = 20;